import {DBConfig} from "ngx-indexed-db";
import {migrationFactory} from "./app/core/factories/IDBMigrationFactory";

export const dbConfig: DBConfig = {
  name: 'db',
  version: 3,
  objectStoresMeta: [
    {
      store: 'tables',
      storeConfig: {keyPath: 'id', autoIncrement: true},
      storeSchema: [
        {name: 'name', keypath: 'name', options: {unique: true}}]
    },
    {
      store: 'bind_tube_categories',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'data', keypath: 'data', options: {unique: false}}
      ]
    },
    {
      store: 'category_standard_titles',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'name', keypath: 'name', options: {unique: false}}
      ]
    },
    {
      store: 'tube_titles',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'name', keypath: 'name', options: {unique: false}}
      ]
    },
    {
      store: 'tube_categories_titles',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'title', keypath: 'title', options: {unique: false}},
        {name: 'tube_id', keypath: 'tube_id', options: {unique: false}},
        {name: 'category_group_id', keypath: 'category_group_id', options: {unique: false}}]
    },
    {
      store: 'channel_titles',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'title', keypath: 'title', options: {unique: false}}
      ]
    },
    {
      store: 'channel_on_tube_titles',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'title', keypath: 'title', options: {unique: false}},
        {name: 'tube_id', keypath: 'tube_id', options: {unique: false}}]
    },
    {
      store: 'channel_group_titles',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'title', keypath: 'title', options: {unique: false}}]
    },
    {
      store: 'channel_association_title',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'title', keypath: 'title', options: {unique: false}}]
    },
    {
      store: 'server_groups',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'name', keypath: 'name', options: {unique: false}}]
    },
    {
      store: 'tube_bucket_titles',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'title', keypath: 'title', options: {unique: false}}]
    },
    {
      store: 'project_titles',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'name', keypath: 'name', options: {unique: false}}]
    },
    {
      store: 'task_type_group_title',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'name', keypath: 'name', options: {unique: false}}]
    },
    {
      store: 'settings_parse_project_title',
      storeConfig: {keyPath: 'id', autoIncrement: false},
      storeSchema: [
        {name: 'name', keypath: 'name', options: {unique: false}}]
    }
  ],
  migrationFactory: migrationFactory
}
